export default __webpack_public_path__ + "static/media/Logo_Trust_JAS@3x.705f9631.png";